import { ObjectMapper } from 'json-object-mapper';
import moment from 'moment-business-days';
import { ExitInterviewStatusType } from 'services/enums/ExitInterviewStatusType.enum';
import { IModel } from '../IModel';
import { Model } from '../model';
import { ExitInterviewEventModel } from './exitInterviewEvent.model';
import { TypeExitInverviewModel } from './typeExitInterview.model';

export class ExitInterviewModel extends Model implements IModel<ExitInterviewModel> {
  public companyId: string | undefined = undefined;
  public companyName: string = '';
  public employeeId: string | undefined = undefined;
  public typeId: string | undefined = undefined;
  public type: TypeExitInverviewModel = new TypeExitInverviewModel();
  public employeeName: string = '';
  public employeeCPF: string = '';
  public employeeRegistration: string = '';
  public scheduledDate: string = '';
  public resignationDate: string = '';
  public companyGroupId: string | undefined = undefined;
  public status: any = ExitInterviewStatusType.PENDING.value;
  public statusText: string = '';
  public justification: string = '';
  public events: ExitInterviewEventModel[] = [];
  public wasEmployeeInitiative: boolean | null = null;
  public participateInExitInterview: boolean | null = null;
  public finalize: boolean = false;

  get statusBadge(): string {
    const status = ExitInterviewStatusType.getBy(this.status);
    const color = this.hasExpired ? 'danger' : status?.className;
    const label = this.hasExpired ? 'Atrasada' : status?.label;

    return `<span class="badge bg-${color} rounded-pill text-wrap">${label}</span>`;
  }

  static create(input: any): ExitInterviewModel {
    return ObjectMapper.deserialize<ExitInterviewModel>(ExitInterviewModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  get hasExpired(): boolean {
    const dateEnd = moment(this.scheduledDate);
    const today = moment();
    if (
      today > dateEnd &&
      [
        ExitInterviewStatusType.CREATED.value,
        ExitInterviewStatusType.LATE.value,
        ExitInterviewStatusType.PENDING.value,
      ].includes(this.status)
    ) {
      return true;
    }
    return false;
  }
}
